// extracted by mini-css-extract-plugin
export default {"StyledHtml":"StyledHtml_StyledHtml__3Zj1f"};